export const MAX_BOUNDS = [
    [-170, -55], // Southwest coordinates
    [200, 75], // Northeast coordinates
  ];

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 3;
export const LONGITUDE_FLIP = 50;
  
export const DEFAULT_MAP_STATE = {
    maxZoom: MAX_ZOOM,
    minZoom: MIN_ZOOM,
    zoom: 0,
    longitude: 0,
    latitude: 0,
};


export const API_HOST = window['__hpi_url__'] || 'https://api.henleypassportindex.com/api/';
export const IMAGE_HOST = window['__hpi_url__'] !== undefined ? '' : 'https://cdn.henleyglobal.com';

//https://cdn.henleyglobal.com/storage/app/media/HOME/passports3.jpg